// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Mo_vy","text":"styles_text__mIIxt","editIcon":"styles_editIcon__sefSn"};